import { render, staticRenderFns } from "./MarketHero.vue?vue&type=template&id=489cfdfc&scoped=true"
import script from "./MarketHero.vue?vue&type=script&lang=js"
export * from "./MarketHero.vue?vue&type=script&lang=js"
import style0 from "./MarketHero.vue?vue&type=style&index=0&id=489cfdfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489cfdfc",
  null
  
)

export default component.exports